export enum QueryBuilderInstrumentsTypes {
    Instrument = "instrument_count",
    StaticInstrument = "static_instrument_count",
}